/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class PortfolioApi extends runtime.BaseAPI {
    /**
     * Create Portfolio
     */
    async v2CreatePortfolioRaw(requestParameters, initOverrides) {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError('file', 'Required parameter "file" was null or undefined when calling v2CreatePortfolio().');
        }
        if (requestParameters['portfolioType'] == null) {
            throw new runtime.RequiredError('portfolioType', 'Required parameter "portfolioType" was null or undefined when calling v2CreatePortfolio().');
        }
        if (requestParameters['name'] == null) {
            throw new runtime.RequiredError('name', 'Required parameter "name" was null or undefined when calling v2CreatePortfolio().');
        }
        if (requestParameters['creationId'] == null) {
            throw new runtime.RequiredError('creationId', 'Required parameter "creationId" was null or undefined when calling v2CreatePortfolio().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file']);
        }
        if (requestParameters['portfolioType'] != null) {
            formParams.append('portfolio_type', requestParameters['portfolioType']);
        }
        if (requestParameters['name'] != null) {
            formParams.append('name', requestParameters['name']);
        }
        if (requestParameters['creationId'] != null) {
            formParams.append('creation_id', requestParameters['creationId']);
        }
        let urlPath = `/api/v2/portfolio`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create Portfolio
     */
    async v2CreatePortfolio(requestParameters, initOverrides) {
        const response = await this.v2CreatePortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete Portfolio
     */
    async v2DeletePortfolioRaw(requestParameters, initOverrides) {
        if (requestParameters['portfolioId'] == null) {
            throw new runtime.RequiredError('portfolioId', 'Required parameter "portfolioId" was null or undefined when calling v2DeletePortfolio().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/portfolio/{portfolio_id}`;
        urlPath = urlPath.replace(`{${"portfolio_id"}}`, encodeURIComponent(String(requestParameters['portfolioId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Delete Portfolio
     */
    async v2DeletePortfolio(requestParameters, initOverrides) {
        const response = await this.v2DeletePortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List Portfolios
     */
    async v2ListPortfoliosRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/portfolio`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List Portfolios
     */
    async v2ListPortfolios(initOverrides) {
        const response = await this.v2ListPortfoliosRaw(initOverrides);
        return await response.value();
    }
    /**
     * Preview Portfolio
     */
    async v2PreviewPortfolioRaw(requestParameters, initOverrides) {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError('file', 'Required parameter "file" was null or undefined when calling v2PreviewPortfolio().');
        }
        if (requestParameters['portfolioType'] == null) {
            throw new runtime.RequiredError('portfolioType', 'Required parameter "portfolioType" was null or undefined when calling v2PreviewPortfolio().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file']);
        }
        if (requestParameters['portfolioType'] != null) {
            formParams.append('portfolio_type', requestParameters['portfolioType']);
        }
        let urlPath = `/api/v2/portfolio/preview`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Preview Portfolio
     */
    async v2PreviewPortfolio(requestParameters, initOverrides) {
        const response = await this.v2PreviewPortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Read Portfolio
     */
    async v2ReadPortfolioRaw(requestParameters, initOverrides) {
        if (requestParameters['portfolioId'] == null) {
            throw new runtime.RequiredError('portfolioId', 'Required parameter "portfolioId" was null or undefined when calling v2ReadPortfolio().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/portfolio/{portfolio_id}`;
        urlPath = urlPath.replace(`{${"portfolio_id"}}`, encodeURIComponent(String(requestParameters['portfolioId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Read Portfolio
     */
    async v2ReadPortfolio(requestParameters, initOverrides) {
        const response = await this.v2ReadPortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Rename Portfolio
     */
    async v2RenamePortfolioRaw(requestParameters, initOverrides) {
        if (requestParameters['portfolioId'] == null) {
            throw new runtime.RequiredError('portfolioId', 'Required parameter "portfolioId" was null or undefined when calling v2RenamePortfolio().');
        }
        if (requestParameters['name'] == null) {
            throw new runtime.RequiredError('name', 'Required parameter "name" was null or undefined when calling v2RenamePortfolio().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        const consumes = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['name'] != null) {
            formParams.append('name', requestParameters['name']);
        }
        let urlPath = `/api/v2/portfolio/{portfolio_id}`;
        urlPath = urlPath.replace(`{${"portfolio_id"}}`, encodeURIComponent(String(requestParameters['portfolioId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Rename Portfolio
     */
    async v2RenamePortfolio(requestParameters, initOverrides) {
        const response = await this.v2RenamePortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Replace Portfolio
     */
    async v2ReplacePortfolioRaw(requestParameters, initOverrides) {
        if (requestParameters['portfolioId'] == null) {
            throw new runtime.RequiredError('portfolioId', 'Required parameter "portfolioId" was null or undefined when calling v2ReplacePortfolio().');
        }
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError('file', 'Required parameter "file" was null or undefined when calling v2ReplacePortfolio().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file']);
        }
        let urlPath = `/api/v2/portfolio/{portfolio_id}`;
        urlPath = urlPath.replace(`{${"portfolio_id"}}`, encodeURIComponent(String(requestParameters['portfolioId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Replace Portfolio
     */
    async v2ReplacePortfolio(requestParameters, initOverrides) {
        const response = await this.v2ReplacePortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const V2CreatePortfolioPortfolioTypeEnum = {
    wind: 'wind',
    solar: 'solar'
};
/**
 * @export
 */
export const V2PreviewPortfolioPortfolioTypeEnum = {
    wind: 'wind',
    solar: 'solar'
};
